import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatCardModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatSelectModule,
  MatTableModule
} from '@angular/material';
import { WelcomeModule } from '~/app/open-age/welcome/welcome.module';
import { SharedModule } from '../../shared/shared.module';
import { AppointmentDetailsComponent } from './appointment-details/appointment-details.component';
import { AppointmentListComponent } from './appointment-list/appointment-list.component';
import { EditAttandanceDialogComponent } from './dialog/edit-attandance/edit-attandance.component';
import { QuickAddPatientsDialogComponent } from './dialog/quick-add-patients-dialog/quick-add-patients-dialog.component';
import { AppointmentLogsComponent } from './appointment-logs/appointment-logs.component';

const components = [
  AppointmentDetailsComponent,
  AppointmentListComponent,
  AppointmentLogsComponent,
  EditAttandanceDialogComponent,
  QuickAddPatientsDialogComponent
];
const thirdPartyModules = [
  MatIconModule,
  MatButtonModule,
  MatFormFieldModule,
  MatInputModule,
  MatAutocompleteModule,
  MatSelectModule,
  MatCardModule,
  MatListModule,
  MatTableModule,
  MatExpansionModule
];
const services = [];
const guards = [];
const pipes = [];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    WelcomeModule,
    SharedModule,
    ...thirdPartyModules,
  ],
  declarations: [...components, ...pipes],
  exports: [...components, ...pipes],
  providers: [...services, ...guards],
  entryComponents: [EditAttandanceDialogComponent, QuickAddPatientsDialogComponent]
})
export class OaWelcomeModule { }
